import QRCode from "react-qr-code";
import zaffloLogo from "../../../assets/fav.png";


export default function BaseQrTemplate({
    hotelName,
    logo,
    unitLabel = "Room",        // default = backward compatibility
    unitNumber,
    roomNumber,               // fallback support
    qrValue,
    bgColor = "#ffffff",
    textColor = "#000000",
}) {

   


    const displayNumber = unitNumber ?? roomNumber;
    const showUnit = typeof displayNumber === "number" && displayNumber > 0;
    return (
        <div
            style={{
                width: "380px",
                height: "560px",
                backgroundColor: bgColor,
                fontFamily: "Arial, Helvetica, sans-serif",
                WebkitFontSmoothing: "antialiased",
                textRendering: "optimizeLegibility",
                boxSizing: "border-box",
            }}
            className="px-6 py-6"
        >
            {/* Logo */}
            <div
                style={{ height: 64 }}
                className="flex items-center justify-center mb-4"
            >
                {logo ? (
                    <img
                        src={logo}
                        crossOrigin="anonymous"
                        alt="Hotel Logo"
                        style={{ maxHeight: 64, maxWidth: 160 }}
                    />
                ) : null}
            </div>

            {/* Hotel Name */}
            <div
                style={{ height: 44 }}
                className="flex items-center justify-center mb-1"
            >
                <h2
                    style={{
                        fontSize: 22,
                        fontWeight: 700,
                        lineHeight: "1.2",
                        textAlign: "center",
                        margin: 0,
                        color: textColor,
                    }}
                >
                    {hotelName}
                </h2>
            </div>

            {/* CTA */}
            <div
                style={{ height: 30 }}
                className="flex items-center justify-center mb-4"
            >
                <p
                    style={{
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                        color: textColor,
                        margin: 0,
                    }}
                >
                    Scan Our Menu
                </p>
            </div>

            {/* QR Section */}
            <div className="flex items-center justify-center mb-4">
                <div
                    style={{
                        backgroundColor: "#ffffff",
                        padding: 16,
                        borderRadius: 14,
                        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                    }}
                >

                    <div style={{ position: "relative", width: 180, height: 180 }}>
                        <QRCode
                            value={qrValue}
                            size={180}
                            level="H"
                        />
                        {/* Zafflo logo overlay */}
                        <img
                            src={zaffloLogo}
                            alt="Zafflo"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                width: 36,
                                height: 36,
                                transform: "translate(-50%, -50%)",
                                backgroundColor: "#ffffff",
                                padding: 4,
                                borderRadius: 8,
                            }}
                        />
                    </div>


                </div>
            </div>

            {/* Room Number */}
            <div
                style={{ height: 36 }}
                className="flex items-center justify-center mb-2"
            >
                <p
                    style={{
                        fontSize: 25,
                        fontWeight: 600,
                        color: textColor,
                        margin: 0,

                    }}
                >
                  {/* Unit Number (Table / Room) */}
<div
  style={{ height: 36 }}
  className="flex items-center justify-center mb-2"
>
  {showUnit ? (
    <p
      style={{
        fontSize: 25,
        fontWeight: 600,
        color: textColor,
        margin: 0,
      }}
    >
      {unitLabel} {displayNumber}
    </p>
  ) : null}
</div>

                </p>
            </div>

            {/* Spacer (fixed height to avoid shift) */}
            <div style={{ height: 36 }} />

            {/* Footer */}
            <div
                style={{ height: 24 }}
                className="flex items-center justify-center"
            >
                {/* Powered by */}
                <div className="text-xs text-gray-500" style={{ color: textColor }}>
                    Powered by{" "}
                    <span className="font-semibold text-[#6cbb23]">Zafflo</span>
                </div>
            </div>
        </div>
    );
}
